import guide from '@/components/decoration/data/guide';

export default [
    guide, // 辅助线
]